<template>
    <el-table
      :data="teams"
      row-key="id"
      @row-click="onRowClick"
    >

      <!-- Name -->
      <el-table-column 
        :label="fields.name.label" 
        :prop="fields.name.name" 
        :resizable="false"
      >
        <template slot-scope="scope">
          <div :style="{ backgroundImage: getTeamAvatar(scope.row) }" class="list__avatar" />
          <span class="list__avatar__name" v-text="presenter(scope.row, 'name')" />
        </template>
      </el-table-column>

      <!-- Program -->
      <el-table-column 
        :label="fields.program.label" 
        :prop="fields.program.name" 
        :resizable="false"
      >
        <template slot-scope="scope">
          <app-i18n
            code="common.none"
            v-if="!teamPrograms(scope.row.programs) || !teamPrograms(scope.row.programs).length"
          />
          <span
            v-else-if="teamPrograms(scope.row.programs).length === 1"
            v-text="teamPrograms(scope.row.programs)[0].label"
          />
        </template>
      </el-table-column>

      <!-- Subprogram -->
      <el-table-column
        :label="fields.subprogram.label"
        :prop="fields.subprogram.name"
        :resizable="false"
      >
        <template slot-scope="scope">
          <app-i18n
            code="common.none"
            v-if="!teamSubprograms(scope.row.programs) || !teamSubprograms(scope.row.programs).length"
          />
          <span
            v-else-if="teamSubprograms(scope.row.programs).length === 1"
            v-text="teamSubprograms(scope.row.programs)[0].label"
          />
        </template>
      </el-table-column>
    </el-table>
</template>

<script>
import { mapGetters } from 'vuex';
import { TeamModel } from '@modules/team/team-model';

const { fields } = TeamModel;

export default {
  name: 'app-player-view-profile-teams',

  props: {
    teams: {
      type: Array,
      required: true
    }
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
    }),
    fields() {
      return fields;
    },
    teamPrograms() {
      return (programsObject) => {
        if (!programsObject) return [];
        return Object.keys(programsObject).map((id) => ({
          id,
          label: programsObject[id].label,
        }));
      };
    },
    teamSubprograms() {
      return (programsObject) => {
        const subprograms = [];

        if (programsObject) {
          Object.values(programsObject).forEach(
            (programObject) => {
              if (!('subprograms' in programObject)) return;
              if (!programObject.subprograms) return;
              Object.keys(
                programObject.subprograms,
              ).forEach((subprogramId) => {
                subprograms.push({
                  id: subprogramId,
                  label:
                    programObject.subprograms[subprogramId]
                      .label,
                });
              });
            },
          );
        }

        return subprograms;
      };
    },
  },

  methods: {
    presenter(record, fieldName) {
      return TeamModel.presenter(record, fieldName);
    },

    getPicture(record) {
      if (!record) return null;
      if (!record.picture) return null;
      return `url("${record.picture.publicUrl}")`;
    },
    getTeamAvatar(row) {
      if (!('logo' in row)) return null;
      if (!(row.logo instanceof Array)) return null;
      if (!row.logo.length) return null;
      return `url("${row.logo[0].publicUrl}")`;
    },

    onRowClick(row, column) {
      if (!('label' in column)) return;
      this.$router.push({
        name: 'teamView',
        params: {
          id: row.id,
        }
      });
    },
  },
};
</script>